<template>
  <div class="form-radio" @click="onClick()">
    <input
      :id="`singleRadio-${label}`"
      type="radio"
      :class="[`form-radio__field`, checked && `form-radio__field--checked`]"
      :name="`singleRadio-${label}`"
      :checked="checked"
      :disabled="disabled"
      @click.stop=""
    />
    <label
      :class="[
        `form-radio__label`,
        hover && `hover`,
        focus && `active focus`
      ]"
      :for="`singleRadio-${label}`"
    >{{ label }}
      <span
        v-if="required"
        class="required"
      ></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "RadioStandard",
  props: {
    label: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    hover: {
      type: Boolean,
      required: true,
    },
    focus: {
      type: Boolean,
      required: true,
    },
    required: { 
      type: Boolean,
      default: false
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick", !this.checked);
    },
  },
};
</script>

<style lang="scss">
  .required:after {
    content:" *";
    color: red;
  }
</style>